import React, { useState } from 'react';
import Checkbox from 'ats/components/checkbox/Checkbox';
import { modalStore } from 'components/layout/modals/ModalStore';

export function ExternalApplicationSendEmailCheckbox({
	checked,
	onChange,
	disabled,
	label
}) {
	return (
		<label
			className={`external-application-send-email ${
				disabled ? 'is-disabled' : ''
			}`.trim()}>
			<input
				type="checkbox"
				checked={checked}
				disabled={disabled}
				onChange={event => onChange(event.target.checked)}
			/>
			<Checkbox checked={checked} />
			<span>{label}</span>
		</label>
	);
}

export default function ExternalApplicationDecisionModal({
	variant = 'reject',
	title,
	message,
	confirmLabel,
	emailLabel,
	hasEmail = true,
	onConfirm
}) {
	const [saving, setSaving] = useState(false);
	const [sendEmail, setSendEmail] = useState(hasEmail);

	const handleConfirm = async () => {
		if (saving) return;
		setSaving(true);
		try {
			await onConfirm?.({ sendEmail: hasEmail && sendEmail });
			modalStore.closeDialog();
		} catch (error) {
			setSaving(false);
		}
	};

	return (
		<div className={`ExternalApplicationDecisionModal is-${variant}`}>
			<div className="decision-modal-top">
				<button
					type="button"
					className="decision-modal-close"
					onClick={() => modalStore.closeDialog()}
					disabled={saving}>
					<img src="/ats/icons/close-icon.svg" alt="" />
				</button>
			</div>
			<h2>{title}</h2>
			<p>{message}</p>
			<ExternalApplicationSendEmailCheckbox
				checked={hasEmail && sendEmail}
				onChange={setSendEmail}
				disabled={saving || !hasEmail}
				label={
					hasEmail ? emailLabel : 'No email on file, no email will be sent'
				}
			/>
			<div className="decision-modal-footer">
				<button
					type="button"
					className="decision-modal-cancel"
					onClick={() => modalStore.closeDialog()}
					disabled={saving}>
					Cancel
				</button>
				<button
					type="button"
					className="decision-modal-confirm"
					onClick={handleConfirm}
					disabled={saving}>
					{confirmLabel}
				</button>
			</div>
		</div>
	);
}
